import { Component, NgZone, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { HttpService } from 'app/services/http.service';
import { validateRut, formatterRut, numberToClp } from 'chilean-formatter';
import { ConfirmationService, MessageService } from 'primeng/api';

@Component({
  selector: 'app-clientes',
  templateUrl: './clientes.component.html',
  styleUrls: ['./clientes.component.scss']
})
export class ClientesComponent implements OnInit {

  usuario: any;
  clientes: any[];
  empresas: any[];
  empresasFiltradas: any[];
  clientesFiltrados: any[];
  estaEditando: boolean = false;
  modoCreaEdita: boolean = false;
  formulario: FormGroup;
  activos: boolean = true;

  constructor(
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private formBuilder: FormBuilder,
    private http: HttpService,
    private ngZone: NgZone
  ) {

    this.usuario = JSON.parse(this.http.getLocalstorage('usuario'))

    this.formulario = this.formBuilder.group({
      _id: '',
      _empresa: '',
      Nombre: ['', Validators.required],
      NombreContacto: ['', Validators.required],
      EmailContacto: '',
      FonoContacto: '',
      RutCliente: '',
      Habilitado: true,

    });

  }

  async ngOnInit(): Promise<void> {
    await this.getEmpresas();
    await this.getClientes();
  }

  async getEmpresas(): Promise<void> {
    console.log('getEmpresas');

    this.empresas = await this.http.getEmpresaService();
    this.ngZone.run(() => { })
  }

  searchEmpresa(event) {
    var filtered: any[] = [];
    var query = event.query;
    for (let i = 0; i < this.empresas.length; i++) {
      let param = this.empresas[i];
      if (param.NombreEmpresa.toLowerCase().indexOf(query.toLowerCase()) >= 0) {
        filtered.push(param);
      }
    }
    this.empresasFiltradas = filtered;
    console.log('this.empresasFiltradas', this.empresasFiltradas);

  }

  nuevoCliente() {
    console.log('pasṕ por nuevoCliente');

    this.estaEditando = false
    this.modoCreaEdita = true

    console.log('this.estaEditando', this.estaEditando);
  }

  delete(event: Event, id) {
    console.log('delete');
    console.log('id', id);
    this.confirmationService.confirm({
      target: event.target,
      message: 'Está seguro?',
      icon: 'pi pi-exclamation-triangle',
      rejectLabel: 'No',
      acceptLabel: 'Si, eliminar',
      accept: () => {
        this.http.deleteClienteService(id)
          .subscribe((data: any) => {
            console.log(data);
            this.getClientes();
          })
        this.messageService.add({
          severity: "info",
          summary: "Listo",
          detail: "El cliente ha sido eliminado"
        });
      },
      reject: () => {
        return;
      }
    });

  }

  cambiaActivo() {
    console.log('cambiaActivo');
    if (this.activos)
      this.clientesFiltrados = this.clientes.filter(e => e.Eliminado == !this.activos)
    else
      this.clientesFiltrados = this.clientes
  }

  guardar(_formValue) {

    let formValue = JSON.parse(JSON.stringify(_formValue))
    formValue.Empresa = this.formulario.controls._empresa.value._id
    console.log('formValue', formValue);

    // return;

    if (this.estaEditando) {

      this.http.updateClienteService(formValue).subscribe((data: any) => {
        console.log('data', data);
        this.getClientes()
        this.messageService.add({
          severity: 'success',
          summary: 'Listo!',
          detail: 'Cliente editado'
        });

        this.modoCreaEdita = false;
        this.estaEditando = false;

        this.limpiaFormulario()
      }, err => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error!',
          detail: err.error
        });
      })

      return;
    }

    this.http.newClienteService(formValue).subscribe((data: any) => {
      console.log('data', data);
      this.getClientes()
      this.messageService.add({
        severity: 'success',
        summary: 'Listo!',
        detail: 'Cliente creado'
      });

      this.modoCreaEdita = false;
      this.limpiaFormulario()
    }, err => {
      this.messageService.add({
        severity: 'error',
        summary: 'Error!',
        detail: err.error
      });
    })

  }

  clientesEmpresas: any[]
  async getClientes(): Promise<void> {
    this.clientes = await this.http.getAllClientesService();

    console.log('clientes', this.clientes);

    this.clientesFiltrados = this.clientes.filter(e => e.Eliminado == !this.activos)

    const hash = this.clientes.reduce((p, c) => (p[c.Empresa._id] ? p[c.Empresa._id].push(c) : p[c.Empresa._id] = [c], p), {})
    this.clientesEmpresas = Object.keys(hash).map(k => ({ 'empresa': k, 'clientes': hash[k] }));
    console.log('this.clientesEmpresas', this.clientesEmpresas)

    this.clientesEmpresas.forEach(element => {
      const empresa = this.empresas.find(e => e._id == element.empresa)
      element.NombreEmpresa = empresa.NombreEmpresa
      element.NombreContacto = empresa.NombreContacto
      element.Habilitado = empresa.Habilitado
    });

    this.ngZone.run(() => { })
  }

  formateaRUT() {
    this.formulario.controls.RutCliente.setValue(formatterRut(this.formulario.controls.RutCliente.value))

    if (!validateRut(this.formulario.controls.RutCliente.value))
      this.formulario.controls.RutCliente.setErrors({ 'incorrect': true })
  }

  cliente: any
  abreModaledita(id) {
    console.log('id:', id);

    this.estaEditando = true
    this.modoCreaEdita = true
    let index = this.clientes.findIndex(e => e._id == id)

    this.cliente = this.clientes[index]
    console.log('cliente', this.cliente);

    this.cliente._empresa = this.cliente.Empresa
    this.formulario.patchValue(this.cliente)
  }

  limpiaFormulario() {
    this.formulario.reset()
    this.modoCreaEdita = false
    this.estaEditando = false
  }

}
